import { render, staticRenderFns } from "./Dnd.vue?vue&type=template&id=31a91c84&scoped=true"
import script from "./Dnd.vue?vue&type=script&lang=ts"
export * from "./Dnd.vue?vue&type=script&lang=ts"
import style0 from "./Dnd.vue?vue&type=style&index=0&id=31a91c84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a91c84",
  null
  
)

export default component.exports